import styled, { css } from "styled-components";
import { pxToRem, withAlpha } from "../../styles/utils";

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  padding: ${({ theme }) => pxToRem(theme.spacing.sm)} ${({ theme }) => pxToRem(theme.spacing.md)};
  border: ${pxToRem(1)} solid ${({ theme }) => withAlpha(theme.colors.ink, 0.1)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme }) => theme.colors.canvas};
  color: ${({ theme }) => theme.colors.ink};
  --autofill-background: ${({ theme }) => theme.colors.canvas};
  --autofill-text-color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};

  /*
    Safari на сенсорных устройствах приближает страницу при фокусе,
    если текст поля меньше 16px. На desktop сохраняем общую rem-шкалу.
  */
  @supports (-webkit-touch-callout: none) {
    @media (hover: none) and (pointer: coarse) {
      font-size: 16px;
    }
  }
  font-family: inherit;
  line-height: 1.25;
  scrollbar-width: none;
  outline: none;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

  ${({ hasError, theme }) =>
    hasError &&
    css`
      border-color: ${theme.colors.danger};
      background: ${withAlpha(theme.colors.brand, 0.15)};
      --autofill-background: ${withAlpha(theme.colors.brand, 0.15)};
    `}

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => withAlpha(theme.colors.brand, 0.35)};
  }

  &:focus,
  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.brand};
    background: ${({ theme }) => withAlpha(theme.colors.brand, 0.15)};
    --autofill-background: ${({ theme }) => withAlpha(theme.colors.brand, 0.15)};
    box-shadow: 0 0 0 ${pxToRem(2)} ${({ theme }) => withAlpha(theme.colors.brand, 0.12)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
    opacity: 1;
  }
`;
